import { render, staticRenderFns } from "./CollectionItemGrid.vue?vue&type=template&id=41a4065d&"
import script from "./CollectionItemGrid.vue?vue&type=script&lang=js&"
export * from "./CollectionItemGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports